import React from 'react';
import PropTypes from 'prop-types';

import { asRequest } from 'next/entities/requests';
import { Shape as PinShape } from 'next/entities/experiences';
import { Shape as FlowShape } from 'next/entities/flows';

import { Heading, Modal, NegativeNotice, Overflow } from 'next/components/ui';
import { FLOW_TYPE, PIN_TYPE } from './constants';
import { singularExperienceTitle } from './lib';
import CreateExperienceForm from './CreateExperienceForm';

const CreateExperienceModal = ({
  onClose,
  onSubmit,
  status,
  type,
  visible,
  ...unhandledProps
}) => {
  const { loading, error } = status;

  return (
    <Modal onClose={onClose} size="m" visible={visible}>
      <Overflow>
        <Heading>Create a {singularExperienceTitle(type)}</Heading>
        {error && (
          <NegativeNotice>
            We're sorry, something went wrong on our end. Try again.
          </NegativeNotice>
        )}
        <CreateExperienceForm
          loading={loading}
          onClose={onClose}
          onSubmit={onSubmit}
          type={type}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...unhandledProps}
        />
      </Overflow>
    </Modal>
  );
};

CreateExperienceModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  status: asRequest(PropTypes.objectOf(PropTypes.oneOf([PinShape, FlowShape]))),
  type: PropTypes.oneOf([FLOW_TYPE, PIN_TYPE]),
  visible: PropTypes.bool,
};

export default CreateExperienceModal;
